import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import paths from "@icarius-router/paths";
import { getAppColor, getAvailablePaths } from "@icarius-app/selectors";
import SocietyClockHeader from "./societyClockHeader";
import HomeIcon from "@material-ui/icons/Home";
import GroupIcon from "@material-ui/icons/Group";
import AssignmentIcon from "@material-ui/icons/Assignment";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";

const useStyles = makeStyles(() => ({
    navButton: {
        textTransform: "none",
        borderRadius: 0,
        transition: "border-radius 0s",
        "&:hover": {
            borderRadius: 6,
        },
    },
}));

const HomeHeader = () => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const availablePaths = useSelector(getAvailablePaths);
    const color = useSelector(getAppColor);

    const headerData = [
        {
            title: getLocalizedString("home"),
            path: paths.home,
            icon: <HomeIcon style={{ color: "var(--mainText)" }} />,
        },
        {
            title: getLocalizedString("feed"),
            path: paths.feed,
            icon: <GroupIcon style={{ color: "var(--mainText)" }} />,
        },
        {
            title: getLocalizedString("myNotes"),
            path: paths.notes,
            icon: <AssignmentIcon style={{ color: "var(--mainText)" }} />,
        },
        {
            title: getLocalizedString("myDesktop"),
            path: paths.myDesktop,
            icon: <DesktopWindowsIcon style={{ color: "var(--mainText)" }} />,
        },
    ];

    const getIsSelected = (path) => {
        if (path === paths.home) {
            //porque si se pone un path que no existe, redirije al home
            return ![paths.notes, paths.myDesktop, paths.feed].includes(location.pathname);
        }
        return location.pathname === path;
    };

    const hasMoreThanHome =
        availablePaths.includes(paths.notes) ||
        availablePaths.includes(paths.myDesktop) ||
        availablePaths.includes(paths.feed);

    return (
        <>
            {hasMoreThanHome && (
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 8,
                        margin: "10px 0px 20px",
                    }}
                >
                    {headerData.map((item) => {
                        if (item.path !== paths.home && !availablePaths.includes(item.path)) return null;
                        return (
                            <Button
                                key={item.path}
                                onClick={() => history.push(item.path)}
                                className={classes.navButton}
                                style={{
                                    borderBottom: getIsSelected(item.path) ? `2px solid ${color}` : "",
                                }}
                            >
                                <div
                                    style={{
                                        width: 150,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        cursor: "pointer",
                                    }}
                                >
                                    {item.icon}
                                    <Typography align="center" className="whiteText" variant="caption">
                                        {item.title}
                                    </Typography>
                                </div>
                            </Button>
                        );
                    })}
                </div>
            )}
            <div style={{ marginTop: hasMoreThanHome ? 0 : 10 }}>
                <SocietyClockHeader />
            </div>
        </>
    );
};

export default HomeHeader;
